<template>
    <div class="align-right">
        <az-call-to-action @click="$emit('click')" slot="actions"
                           css-class="text-uppercase d-flex align-center botao-cancelar-proposta">
            <v-icon color="grey">
                close
            </v-icon>
            Cancelar Envio
        </az-call-to-action>
    </div>
</template>

<script>
export default {
    name: 'BotaoCancelarPropostaComDipsuta'
}
</script>

<style scoped lang="stylus">
    .action-primary
        padding 10px 15px
        border 1px solid #7aa329
        background-color #7aa329 !important
        color #fff !important
        margin-left 10px
        border-radius 2px

        i
            margin-right 0
    .botao-cancelar-proposta
        color #777 !important
</style>
